




































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import _ from 'lodash'
import { getModule } from 'vuex-module-decorators'
import SolicitacaoStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoStore'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import EventBus from '@/plugins/EventBus'
import { EquipamentoGrupo, EquipamentoGrupoDaSolicitacao, EquipamentoGrupoChild } from '@/types/interfaces/Solicitacao'
import ReservaSalaStore from '@/components/ReservaSala/Store/ReservaSalaStore'

@Component
export default class ComponentModalEquipamentos extends Vue {
  inputSearch: string = ''
  loading: any = {
    searchProcedimento: false,
    listText: 'Equipamento não encontrado.',
  }

  surgerySolicitationEquipmentData: any = []

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get getSolicitacaoStore() {
    return getModule(SolicitacaoStore, this.$store)
  }

  get getReservaSalaStore() {
    return getModule(ReservaSalaStore, this.$store)
  }

  get equipmentSelectionConfirmed() {
    return this.getBackofficeGlobalStore.equipmentSelectionConfirmed
  }

  set equipmentSelectionConfirmed(confirmed: boolean) {
    this.getBackofficeGlobalStore.setEquipmentSelectionConfirmation(confirmed)
  }

  get hasHighlightedEquipments() {
    return this.getEquipamentoGruposApi.some(item => item.hasEmphasis === true)
  }

  get selectedEquipments() {
    return this.getEquipamentoGruposDaSolicitacao.filter(item => !!item.equipamentSelected)
  }

  get getRequestMessage() {
    return this.getSolicitacaoStore.requestMessage
  }

  get getInputSearch() {
    return this.inputSearch
  }

  set getInputSearch(value) {
    this.inputSearch = value
  }

  get showModalEquipamento() {
    return this.getBackofficeGlobalStore.modal.equipamentos
  }

  set showModalEquipamento(val: boolean) {
    this.getBackofficeGlobalStore.setModal({ name: 'equipamentos', value: val })
  }

  get getEquipamentoGruposApi() {
    return this.getBackofficeGlobalStore.equipamentoGruposApi
  }

  get getEquipamentoGruposDaSolicitacao() {
    return this.getBackofficeGlobalStore.equipamentoGruposDaSolicitacao
  }

  get hospitalSelecionado() {
    return this.getReservaSalaStore.hospitalSelecionado
  }

  get selectedHospitalFromNetwork() {
    const { data } = this.hospitalSelecionado

    if (data) {
      return {
        name: data.nome,
        id: data.id,
      }
    }

    return null
  }

  get hasHospitalFromNetwork() {
    return this.getReservaSalaStore.hospitaisRede.length > 0
  }

  get hasHospitalFromNetworkAndSelectedHospitalFromNetwork() {
    const { hospitalId: surgerySolicitationHospitalId } = this.getBackofficeGlobalStore.solicitacao

    if (this.hasHospitalFromNetwork
      && this.selectedHospitalFromNetwork
      && this.selectedHospitalFromNetwork.id !== surgerySolicitationHospitalId) {
      return true
    }

    return false
  }

  @Watch('showModalEquipamento')
  onChangeGetShowModalEquipamento(opened) {
    setTimeout(() => {
      const input = document.querySelector(
        '.equipamento-backoffice-input input',
      ) as HTMLInputElement
      this.getInputSearch = ''
      if (opened) {
        input.focus()
      } else {
        input.blur()
      }
    }, 100)

    if (opened) {
      this.equipmentSelectionConfirmed = false

      this.surgerySolicitationEquipmentData = this.getBackofficeGlobalStore.equipamentoGruposDaSolicitacao.map(item => ({ ...item }))

      this.surgerySolicitationEquipmentData = this.surgerySolicitationEquipmentData.filter(
        item => !this.getEquipamentoGruposDaSolicitacao.some(dupe => dupe.id === item.id && dupe.equipamentSelected),
      )
    }

    this.$forceUpdate()
  }

  closeEquipmentModal() {
    this.showModalEquipamento = false
    this.equipmentSelectionConfirmed = false
    this.getBackofficeGlobalStore.clearEquipamentoGruposApi()
    this.getBackofficeGlobalStore.clearEquipamentosApi()
  }

  toggleBodyOverflow(isOpen: Boolean) {
    const body = document.querySelector('body') as HTMLBodyElement
    const noOverflowClass = 'modal-is-open'

    if (body !== null) {
      body.classList.remove(noOverflowClass)
      if (isOpen) {
        body.classList.toggle(noOverflowClass)
      }
    }
  }

  async handleEquipmentChange(equipmentGroup, equipment: EquipamentoGrupoChild) {
    const parsedEquipmentGroup = {
      ...equipmentGroup,
      equipamentSelected: equipment,
    }

    if (equipment.checked) {
      await this.getBackofficeGlobalStore.postEquipamento(equipment)
    } else {
      EventBus.$emit('setLoadingRequest', { status: true, text: 'Carregando...' })

      await this.getBackofficeGlobalStore.deleteSurgerySolicitationEquipmentById({
        surgerySolicitationId: this.getBackofficeGlobalStore.solicitacao.id,
        equipmentId: equipment.id,
      })

      const index = this.getEquipamentoGruposDaSolicitacao.findIndex(item => item.equipamentSelected && item.equipamentSelected.id === equipment.id)

      if (index !== -1) {
        this.getEquipamentoGruposDaSolicitacao.splice(index, 1)
      }

      EventBus.$emit('clearLoadingRequest')
    }
  }

  async addEquipment(equipamentoGrupo: EquipamentoGrupo) {
    let equipments: EquipamentoGrupoChild[] = []

    EventBus.$emit('setLoadingRequest', {
      status: this.getRequestMessage.status,
      text: this.getRequestMessage.post,
    })

    if (this.hasHospitalFromNetwork) {
      equipments = equipamentoGrupo.equipamentos
        .filter(equipamento => equipamento.status === 'Ativo')
        .map(equipamento => ({
          ...equipamento,
          checked: equipamentoGrupo.equipamentSelected && equipamentoGrupo.equipamentSelected.id === equipamento.id,
        }))
    } else {
      equipments = [equipamentoGrupo.equipamentSelected as any]
    }

    const equipamentoGrupoDaSolicitacao: EquipamentoGrupoDaSolicitacao = {
      ...equipamentoGrupo.grupoEquipamento,
      equipamentSelected: equipamentoGrupo.equipamentSelected,
      equipamentos: equipments,
    }

    this.getBackofficeGlobalStore.addEquipamento(equipamentoGrupoDaSolicitacao)
    await this.getBackofficeGlobalStore.postEquipamento(equipamentoGrupo.equipamentSelected!)

    this.$forceUpdate()

    EventBus.$emit('clearLoadingRequest')
  }

  async removeEquipment(equipamentoGrupoDaSolicitacao: EquipamentoGrupoDaSolicitacao) {
    EventBus.$emit('setLoadingRequest', {
      status: this.getRequestMessage.status,
      text: this.getRequestMessage.deleteMessage,
    })

    if (this.hasHospitalFromNetwork) {
      if (equipamentoGrupoDaSolicitacao.equipamentSelected) {
        await this.getBackofficeGlobalStore.deleteSurgerySolicitationEquipmentById({
          surgerySolicitationId: this.getBackofficeGlobalStore.solicitacao.id,
          equipmentId: equipamentoGrupoDaSolicitacao.equipamentSelected.id,
        })

        const index = this.getEquipamentoGruposDaSolicitacao.findIndex(
          item => item.equipamentSelected
            && item.equipamentSelected.id === equipamentoGrupoDaSolicitacao.equipamentSelected!.id,
        )

        if (index !== -1) {
          this.getEquipamentoGruposDaSolicitacao.splice(index, 1)
        }
      }
    } else {
      this.getBackofficeGlobalStore.removeEquipamento(equipamentoGrupoDaSolicitacao)

      const equipament = equipamentoGrupoDaSolicitacao.equipamentSelected!

      await this.getBackofficeGlobalStore.deleteEquipamento(equipament)
      this.$forceUpdate()
    }

    EventBus.$emit('clearLoadingRequest')
  }

  debounce = _.debounce(
    (hospitalId, searchText, hasHospitalFromNetwork) => this.getBackofficeGlobalStore.getEquipmentGroupByHospitalId({ hospitalId, searchText, hasHospitalFromNetwork }),
    600,
  )

  search() {
    let hospitalId
    const { hospitalId: surgerySolicitationHospitalId } = this.getBackofficeGlobalStore.solicitacao

    if (this.getReservaSalaStore.hospitaisRede.length > 0) {
      const { data } = this.hospitalSelecionado
      const { id: hospitalIdFromNetwork } = data

      if (surgerySolicitationHospitalId === hospitalIdFromNetwork) {
        hospitalId = surgerySolicitationHospitalId
      } else {
        hospitalId = hospitalIdFromNetwork
      }
    } else {
      hospitalId = surgerySolicitationHospitalId
    }


    if (this.inputSearch.length === 0 || this.inputSearch.length > 2) {
      this.debounce(hospitalId, this.inputSearch, this.hasHospitalFromNetwork)
    }
  }

  async confirmEquipmentSelection() {
    try {
      if (this.hasHospitalFromNetwork && !this.equipmentSelectionConfirmed) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Para prosseguir, confirme que está ciente da seleção dos equipamentos', icon: 'warning', color: '#C62828' })
      } else {
        this.surgerySolicitationEquipmentData.forEach(async (equipment: EquipamentoGrupoDaSolicitacao) => {
          await this.getBackofficeGlobalStore.deleteEquipamento(equipment)
        })

        this.showModalEquipamento = false
        this.getBackofficeGlobalStore.clearEquipamentoGruposApi()
        this.getBackofficeGlobalStore.clearEquipamentosApi()

        EventBus.$emit('setSnackbar', { show: true, text: 'Equipamentos atualizados', icon: 'done', color: '#2E7D32' })
      }
    } catch (error) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Ocorreu um erro ao configurar equipamentos, tente novamente', icon: 'warning', color: '#C62828' })
    }
  }
}
